import { VersionHistoryResponse } from "@/types/VersionHistory";
import axiosInstance from "./axiosInstance";


export const getVersionView = async (
  materialPlant: string,
  materialNumber: string

): Promise<VersionHistoryResponse> => {
  const response = await axiosInstance.get<VersionHistoryResponse>(
    "/api/view-history",
    {
      params: { materialPlant, materialNumber },
    }
  );

  return response.data;
};
